import Navigation from "./components/navigation";
import Footer from "./components/footer";
import { companyName, navigation } from "./config/constants";
import HeadingTitle from "./pkg/components/heading-title";
import SubHeadingTitle from "./pkg/components/sub-heading-title";
import Paragraph from "./pkg/components/paragraph";
import TightMain from "./pkg/components/tight-main";
import Link from "./pkg/components/link";

function License() {
    return (
        <>
            <Navigation companyName={companyName} navigation={navigation} />

            <TightMain>
                <HeadingTitle>License</HeadingTitle>

                <SubHeadingTitle>Perpetual Fallback Licenses</SubHeadingTitle>

                <Paragraph>
                    The perpetual fallback license is our standard license that comes with every product,
                    except if we explicitly state otherwise.
                </Paragraph>

                <Paragraph>
                    Perpetual fallback licenses give you access to the latest version of the product that is available
                    on the day of your purchase forever. You can use this version as long as you wish but have to
                    extend the access to updates and support after every year.
                </Paragraph>

                <Paragraph>
                    You can usually renew the license yearly and lock in the latest version or upgrade to a
                    lifetime license at any time. If your license is still active and receives updates, upgrades
                    to lifetime are often discounted.
                </Paragraph>


                <SubHeadingTitle>Lifetime Licenses</SubHeadingTitle>

                <Paragraph>
                    A lifetime license is similar to the perpetual fallback license but gives you access to all versions of
                    the software that we'll ever make in the future. So if you buy a lifetime license, you are set forever
                    and won't have to pay for updates of this product ever again.
                </Paragraph>

                <Paragraph>
                    Lifetime licenses often make sense for businesses that have a growing team of developers and want to
                    make sure that they can use the product in the future without having to pay for it again. You can
                    re-assign the license to a different user at any time, so you don't need to buy new licenses if
                    someone leaves your team and someone else joins.
                </Paragraph>

                <Paragraph>
                    We believe that lifetime licenses are healthy to our business as they allow us to plan ahead and
                    that there is an infinite amount of customers for our products. Every day, new developers join the
                    community and need tools to build their applications. We support them and won't run out of
                    customers anytime soon.
                </Paragraph>


                <SubHeadingTitle>Subscription Licenses</SubHeadingTitle>

                <Paragraph>
                    We only use subscriptions for products that require a lot of maintenance, support and dedicated infrastructure.
                    These products are often hosted by us and require a lot of resources to run, so we can't offer them as perpetual
                    or lifetime licenses.
                </Paragraph>

                <Paragraph>
                    Subscriptions are usually billed monthly or yearly and can be cancelled at any time. If you cancel them, you lose
                    access to these tools after your current billing cycle.
                </Paragraph>

                <Paragraph>
                    As a business with subscription fatige, we try to avoid them where we can.
                </Paragraph>

                <Paragraph>
                    If you have any question about our licenses, please <Link href="mailto:hello@protoku.be">contact us</Link>
                    &nbsp;or request <Link href="mailto:hello@protoku.be">an individual quote</Link> for your team.
                </Paragraph>
            </TightMain>

            <Footer />
        </>
    );
}

export default License;
